<template>
  <b-modal ref="supplier-card-modal" @ok="supplierCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.suppliers.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.name"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="name"
          :state="isNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.responsiblePersonName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="responsiblePersonName"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.responsiblePersonPhone"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="responsiblePersonPhone"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.codeEdrpou"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="codeEdrpou"
          :state="isCodeEdrpouValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.filia"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="filia"
          :state="isFiliaValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.fuelDepo"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelDepoId"
          :state="isFuelDepoValid"
          :options="fuelDepoOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { azkService } from "../../../../services";

export default {
  name: "CreateSupplierPage",
  props: {
    fuelDepos: Array,
    suppliers: Array,
  },
  components: {},
  data() {
    return {
      validationErrorMessage: null,
      fuelDepoOptions: [],
      name: null,
      responsiblePersonName: null,
      responsiblePersonPhone: null,
      codeEdrpou: null,
      filia: null,
      fuelDepoId: null,
     
      isNameValid: null,
      isCodeEdrpouValid: null,
      isFiliaValid: null,
      isFuelDepoValid: null
    };
  },
  methods: {
    open() {
      this.name = null;
      this.responsiblePersonName = null;
      this.responsiblePersonPhone = null;
      this.codeEdrpou = null;
      this.filia = null;
      this.fuelDepoId = null;
      
      this.validationErrorMessage = null;
      this.isNameValid = null;
      this.isCodeEdrpouValid = null;
      this.isFiliaValid = null;
      this.isFuelDepoValid = null;
      this.fuelDepoOptions = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        this.fuelDepoOptions.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      this.$refs["supplier-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.name) {
        this.isNameValid = false;
        isValid = false;
      } else {
        this.isNameValid = null;
      }

      if (!this.codeEdrpou) {
        this.isCodeEdrpouValid = false;
        isValid = false;
      } else {
        this.isCodeEdrpouValid = null;
      }

      if (!this.filia) {
        this.isFiliaValid = false;
        isValid = false;
      } else {
        this.isFiliaValid = null;
      }

      if (!this.fuelDepoId) {
        this.isFuelDepoValid = false;
        isValid = false;
      } else {
        this.isFuelDepoValid = null;
      }

      return isValid;
    },
    async supplierCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const fuelDepoId = parseInt(this.fuelDepoId);
      const supplier = this.suppliers.find(x => x.fuelDepoId == fuelDepoId);

      const supplierCard = {
        name: this.name,
        responsiblePersonName: this.responsiblePersonName,
        responsiblePersonPhone: this.responsiblePersonPhone,
        codeEdrpou: this.codeEdrpou,
        filia: this.filia,
        clientId: supplier.clientId,
        fuelDepoId: fuelDepoId
      };

      const createSupplierResponse = await azkService.createSupplier(supplierCard);

      if (
        createSupplierResponse.isSuccess &&
        createSupplierResponse.data &&
        createSupplierResponse.data.countInsertedRows == 1
      ) {
        this.$emit("supplierCreatedSuccessEvent", this.supplier);
      } else {
        this.$emit("supplierCreatedFailEvent");
      }
    },
  },
};
</script>
